<template>
  <div>
        <!-- HEADER -->
        <header class="header">

            <a href="#" class="logo">
                <img src="assets/img/logo-header.svg" title="EinsteinFI" alt="EinsteinFI" />
            </a>

            <a href="#" class="logo-animation">
                <img class="logo-symbol" src="assets/img/einstein-animation.gif" title="EinsteinFI" alt="EinsteinFI" />
                <img class="logo-text" src="assets/img/logo-header-text-only.svg" title="EinsteinFI" alt="EinsteinFI" />
            </a>

            <nav class="menu">
                <ul>
                    <li>
                        <v-menu right bottom offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" text>
                                    About
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>What makes us different</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Applying FI to your investments</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Your Team</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>What if</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </li>
                    <li>
                        <v-menu right bottom offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" text>
                                    Financial Tools
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Financial Planner</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Risk Analysis</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Savings Calculator</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>On Track for Retirement</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </li>
                    <li>
                        <v-menu right bottom offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" text>
                                    Education
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Library</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </li>
                    <li>
                        <v-menu right bottom offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" text>
                                    Community
                                </v-btn>
                            </template>
                            <v-list :elevation="0">
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Enjoy Life</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Giving Back</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="() => {}">
                                    <v-list-item-title>Support our Friends</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </li>

                    <li>
                        <v-btn depressed color="primary" @click="showGetStarted">
                            Get Started
                        </v-btn>
                    </li>
                </ul>
            </nav>

        </header>

        <!-- FIRST -->
        <div class="area-first">

            <h1 class="text-headline">
                Plan and <span class="text-bold">Invest <span class="text-blue">Smarter.</span></span>
            </h1>

        </div>

        <!-- VIDEOS -->
        <div class="area-videos">

            <div class="videos">

                <video class="" autoplay="" loop="" playsinline="" muted="" style="z-index: 2;">
                    <source src="assets/videos/video-test.mp4" type="video/mp4">
                </video>

            </div>

            <h1 class="text-headline">

                <span class="first-line"
                    data-aos="fade-in"
                    data-aos-delay="0"
                    data-aos-duration="700"
                    data-aos-easing="ease-in"
                >
                    Investing Should be
                </span>

                <span class="second-line"
                    data-aos="fade-in"
                    data-aos-delay="0"
                    data-aos-duration="700"
                    data-aos-easing="ease-in"
                >
                    <span>Fun</span>, <span>Easy</span> and <span>Effective.</span>
                </span>

            </h1>

        </div>





        <!-- FIRST -->
        <div class="area-second">

            <div class="area-container">

                <h1 class="text-headline"
                    data-aos="fade-in"
                    data-aos-delay="0"
                    data-aos-duration="700"
                    data-aos-easing="ease-in"
                >
                    What if everything you had been told about investing was wrong? What if there was a <span>simpler</span>, <span>better</span>, and <span>lower cost</span> way to invest?
                </h1>

                <button @click="showGetStarted"
                    data-aos="zoom-in"
                    data-aos-delay="0"
                    data-aos-duration="300"
                    data-aos-easing="ease-in"
                >
                    Get Started
                </button>

            </div>

        </div>





        <!-- INVESTMENTS -->
        <div class="area-investments">

            <div class="area-container">

                <h1 class="text-headline"
                    data-aos="fade-in"
                    data-aos-delay="0"
                    data-aos-duration="700"
                    >
                    <span class="first-line">
                        Do you have the
                    </span>
                    <span class="second-line">
                        <span class="strong">right <span class="text-blue">investments</span> for you</span>?
                    </span>
                </h1>

                <span class="sub-headline"
                    data-aos="fade-in"
                    data-aos-delay="150"
                    data-aos-duration="700"
                    >
                    Are your savings on track?
                    <br>
                    When should you take Social Security?
                    <br>
                    When can you retire?
                </span>

                <span class="description"
                    data-aos="fade-in"
                    data-aos-delay="300"
                    data-aos-easing="ease-in"
                    >
                    EinsteinFI can answer these questions, build your plan and manage your investments and more – at your convenience.  Get in control of your finances and your financial life.  No more allowing someone else to control your financial future, no more wondering if you will have the funds you need, no more high fees and commissions.  We will give you the tools and guidance to navigate the financial market with confidence!
                </span>

                <div class="illustration">
                    <img src="assets/img/illu-1.png" />
                </div>

            </div>

        </div>





        <!-- FIRE ADVISOR -->
        <div class="area-screens" v-bind:class="{ 'new-color': reachedScreens }">


            <span class="area-container">

                <img src="assets/img/screens.png" />

            </span>


        </div>





        <!-- PHOTO -->
        <div class="area-photo">

            <v-parallax src="assets/img/istockphoto-637224992-2048x2048.jpg" title="Happy family" alt="Happy family"></v-parallax>

        </div>





        <!-- BULLETS -->
        <div class="area-bullets">

            <div class="area-container">

                <span class="bullet"
                    data-aos="fade-in"
                    data-aos-delay="300"
                    data-aos-duration="700"
                    data-aos-easing="ease-in"
                >
                    <span class="icon">
                        <img src="assets/img/icon-control-w.svg" />
                    </span>
                    <h2 class="text-headline">
                        Stay in <span>control</span>
                    </h2>
                    <span class="description">
                        We provide professional management, robust planning and everything you would expect from a financial firm at a fraction of the cost.
                    </span>
                </span>

                <span class="bullet bullet-right"
                    data-aos="fade-in"
                    data-aos-delay="300"
                    data-aos-duration="700"
                    data-aos-easing="ease-in"
                >
                    <span class="icon">
                        <img src="assets/img/icon-management-w.svg" />
                    </span>
                    <h2 class="text-headline">
                        State of the Art <br><span>Investment Management</span>
                    </h2>
                    <span class="description">
                        Your investments will be managed in a manner that are aligned with your goals and risk tolerances. We are not a “robo” advisor, we use technology and old fashioned technical analysis to seek a better outcome.
                    </span>
                </span>

                <span class="bullet"
                    data-aos="fade-in"
                    data-aos-delay="300"
                    data-aos-duration="700"
                >
                    <span class="icon">
                        <img src="assets/img/icon-people-w.svg" />
                    </span>
                    <h2 class="text-headline">
                        Technology backed <br><span>by real people</span>
                    </h2>
                    <span class="description">
                        Why not combine the best of both worlds. Use technology to get a better outcome and reduce costs, our people will keep it human! Robo advisors are not the answer, technology can help make better decisions, but the human can help ensure that You will stay the focus of your plan and your goals are the focus of your investments. The benefits of Smart Technology backed up by a human advisor and state of the art investment management.
                    </span>
                </span>

            </div>

        </div>




        <!-- METHOD -->
        <div class="area-method">

            <div class="area-container">

                <span class="text-headline"
                    data-aos="fade-in"
                    data-aos-delay="150"
                    data-aos-duration="700"
                    >
                    A <span>Smarter</span> Method = A <span>Smarter</span> Result
                </span>

                <ul>
                    <li
                    data-aos="fade-in"
                    data-aos-delay="200"
                    data-aos-duration="700"
                    >
                    Plan and Invest<br>With Confidence</li>
                    <li
                    data-aos="fade-in"
                    data-aos-delay="350"
                    data-aos-duration="700"
                    >
                    Active Investment<br>Management</li>
                    <li
                    data-aos="fade-in"
                    data-aos-delay="500"
                    data-aos-duration="700"
                    >
                    Talk to a<br>human advisor</li>
                    <li
                    data-aos="fade-in"
                    data-aos-delay="650"
                    data-aos-duration="700"
                    >
                    Access<br>Your 24/7</li>
                    <li
                    data-aos="fade-in"
                    data-aos-delay="800"
                    data-aos-duration="700"
                    >
                    No More<br>Hidden Fees</li>
                </ul>

            </div>

        </div>




        <!-- BETTER -->
        <div class="area-better">

            <div class="area-container">

                <h1 class="text-headline"
                    data-aos="fade-in"
                    data-aos-delay="0"
                    data-aos-duration="700"
                    >
                    There Truly is a <span>Smarter Way.</span>
                </h1>

                <div class="illustration">
                    <img src="assets/img/illu-3.png" />
                </div>

                <div class="area-money">

                    <span class="item flex-g-2"
                        data-aos="fade-in"
                        data-aos-delay="200"
                        data-aos-duration="700"
                        >
                        <span class="text-title">
                            See all your accounts in one place
                        </span>
                        <span class="description">
                            Get a real-time view of all of your accounts in our friendly portal.
                        </span>
                    </span>

                    <span class="item flex-g-2"
                        data-aos="fade-in"
                        data-aos-delay="350"
                        data-aos-duration="700"
                        >
                        <span class="text-title">
                            Plan for now and Plan for retirement
                        </span>
                        <span class="description">
                            Use our tools to custom craft, manage and adjust your plan, anytime, anywhere.
                        </span>
                    </span>

                    <span class="item flex-g-3"
                        data-aos="fade-in"
                        data-aos-delay="500"
                        data-aos-duration="700"
                        >
                        <span class="text-title">
                            Licensed advisors to help answer your questions
                        </span>
                        <span class="description">
                            Licensed financial professionals will be available to assist your with any questions you have and with your planning needs, at no extra charge.
                        </span>
                    </span>

                </div>

            </div>

        </div>





        <!-- ADVICES -->
        <div class="area-advices">

            <div class="area-container">

                <div class="area-safety">

                    <span class="icon"
                        data-aos="fade-in"
                        data-aos-delay="300"
                        data-aos-easing="ease-in"
                        >
                        <img src="assets/img/icon-safety.svg" />
                    </span>

                    <div class="display-flex-col">

                        <h1 class="text-headline"
                            data-aos="fade-in"
                            data-aos-delay="300"
                            data-aos-easing="ease-in"
                            >
                            Safety is <span>our commitment</span> to you.
                        </h1>

                        <span class="sub-headline"
                            data-aos="fade-in"
                            data-aos-delay="300"
                            data-aos-easing="ease-in"
                            >
                            We will protect your account with the highest standards of security available.
                        </span>

                        <span class="description"
                            data-aos="fade-in"
                            data-aos-delay="300"
                            data-aos-easing="ease-in"
                            >
                            Securities in Darwin SA accounts are insured up to $500,000 by the SIPC.
                            <br><br>
                            Darwin SA checking accounts may be insured to $250,000 by FDIC insurance.
                            <br><br>
                            We are a technology-first company that utilizes the latest in information and security.
                            <br><br>
                            We use state-of-the-art data encryption when handling your financial information and<br>two-factor authentication (2FA) protection.
                        </span>

                    </div>

                </div>

            </div>

        </div>





        <!-- EVERYTHING -->
        <div class="area-everything">

            <div class="area-container">

                <h1 class="text-headline"
                    data-aos="fade-in"
                    data-aos-delay="0"
                    data-aos-easing="ease-in"
                    >
                    Simply a <span>Smarter</span> Everything.
                </h1>

                <button @click="showGetStarted"
                    data-aos="fade-in"
                    data-aos-delay="150"
                    data-aos-easing="ease-in"
                    >
                    Let's get started?
                </button>

            </div>

        </div>





        <!-- FOOTER -->
        <div class="area-footer">

            <div class="area-container">

                <div class="content">

                    <div class="logo">

                        <img src="assets/img/logo-footer.svg" title="EinsteinFI" alt="EinsteinFI" />

                        <ul>
                            <li><a href="https://www.linkedin.com/" target="_blank"><img src="assets/img/social-linkedin.svg" title="EinsteinFI in Linkedin" alt="EinsteinFI in Linkedin" /></a></li>
                            <li><a href="https://twitter.com/" target="_blank"><img src="assets/img/social-twitter.svg" title="EinsteinFI in Twitter" alt="EinsteinFI in Twitter" /></a></li>
                            <li><a href="https://www.facebook.com/" target="_blank"><img src="assets/img/social-facebook.svg" title="EinsteinFI in Facebook" alt="EinsteinFI in Facebook" /></a></li>
                            <li><a href="https://www.instagram.com/" target="_blank"><img src="assets/img/social-instagram.svg" title="EinsteinFI in Instagram" alt="EinsteinFI in Instagram" /></a></li>
                            <li><a href="https://www.youtube.com/" target="_blank"><img src="assets/img/social-youtube.svg" title="EinsteinFI in Youtube" alt="EinsteinFI in Youtube" /></a></li>
                        </ul>

                        <span>© 2020 All rights reserved</span>

                    </div>

                    <div class="links">

                        <ul>
                            <li><a href="#">About</a></li>
                            <li><a href="#">Company</a></li>
                            <li><a href="#">Culture</a></li>
                            <li><a href="#">Careers</a></li>
                        </ul>

                        <ul>
                            <li><a href="#">Legal</a></li>
                            <li><a href="#">Terms of Use</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Agreements</a></li>
                            <li><a href="#">Disclosures</a></li>
                        </ul>

                        <ul>
                            <li><a href="#">Learn More</a></li>
                            <li><a href="#">Retirement</a></li>
                            <li><a href="#">Insights</a></li>
                            <li><a href="#">Education</a></li>
                            <li><a href="#">Articles</a></li>
                        </ul>

                        <ul>
                            <li><a href="#">Questions</a></li>
                            <li><a href="#">Support Center</a></li>
                            <li><a href="#">Service Status</a></li>
                            <li><a href="#">Press Inquiries</a></li>
                        </ul>

                    </div>

                </div>

                <div class="disclaimer">
                    Investment Advisory Services offered through Harwood Advisory Group, LLC. Insurance products and services offered through Harwood Insurance Group.  Insurance and annuity products are backed by the claims paying ability of the issuing company.  Harwood Advisory Group, Harwood Insurance Group and Harwood Financial Group are affiliated companies. <span>Terms of Service</span>
                </div>

            </div>

        </div>

        <!-- SIGN UP -->
        <div class="pop-sign-up" v-bind:class="{ 'pop-visible': buttonPop }" v-if="!buttonPopClose">
            <v-card class="d-inline-block mx-auto pop-sign-up-card" :elevation="4">
                <v-container>
                    <v-btn icon x-small @click="buttonPopClose=true" class="pop-sign-up-close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-row justify="center">
                        <img class="logo-symbol" src="assets/img/einstein-animation-white.gif" title="EinsteinFI" alt="EinsteinFI" />
                    </v-row>
                    <v-row>
                        <v-btn text class="pop-sign-up-cta" @click="showGetStarted">
                            <span>Get Started</span>
                        </v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </div>

      <cookie-banner v-if="!adminMode" />

  </div>
</template>
<script>
import '../assets/css/style.scss'
import AOS from 'aos';
import 'aos/dist/aos.css';
import {mapGetters, mapActions, mapState} from "vuex";
import GetStartedModal from "@/components/modal/GetStartedModal";
import CookieBanner from "@/components/CookieBanner";
// import TwoStepVerificationModal from "@/components/modal/TwoStepVerificationModal";

AOS.init({
  once: true
});

export default {
    name: 'Home',
    components: {
        CookieBanner,
    },
    computed: {
        ...mapState('auth', [
           'adminMode'
        ]),
        ...mapGetters('auth', [
            'isLogged',
            'user'
        ]),
        ...mapGetters('draggableNavigation', [
            'homePage'
        ])
    },
    data() {
        return {
            cookiesMsg: true,
            scrollVideo: 0,
            scrollBullets: 0,
            scrollMethod:0,
            scrollInvestments:0,
            scrollEverything:0,
            reachedBullets:false,
            reachedScreens:false,
            buttonPop:false,
            buttonPopClose:false,
            stay: false,
            showTwoStepVerification: true,
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        ...mapActions('auth', [
            'browseAsAdmin'
        ]),
        showGetStarted() {
            if (! this.isLogged) {
                this.$modal.show(GetStartedModal, {}, {
                    height: 'auto',
                    width: '60%',
                    name: 'GetStartedModal'
                });
            } else {
                this.$router.push({ name: 'GetStarted' });
            }
        },
        handleScroll() {
            if (!this.buttonPopClose) {
                this.scrollVideo = this.$el.querySelector('.area-videos').getBoundingClientRect().y;
                this.scrollBullets = this.$el.querySelector('.area-bullets').getBoundingClientRect().y;
                this.scrollMethod = this.$el.querySelector('.area-method').getBoundingClientRect().y;
                this.scrollEverything = this.$el.querySelector('.area-everything').getBoundingClientRect().y;
                this.scrollInvestments = this.$el.querySelector('.area-investments').getBoundingClientRect().y;
                this.scrollScreens = this.$el.querySelector('.area-screens').getBoundingClientRect().y;

                if (this.scrollScreens<=0) {
                    this.reachedScreens = true;
                }

                if (this.scrollScreens>0) {``
                    this.reachedScreens = false;
                }

                if (this.scrollInvestments<=0) {
                    this.buttonPop=true;
                }
                if (this.scrollInvestments>0) {
                    this.buttonPop=false;
                }

                if (this.scrollEverything<=0) {
                    this.buttonPop=false;
                }
            }
        }
    },
}

// INTERCOM
var APP_ID = "zih2c86p";
window.intercomSettings = {
    app_id: APP_ID
  };
(function() {var w=window;var ic=w.Intercom;if (typeof ic==="function") {ic('reattach_activator');ic('update',w.intercomSettings);} else {var d=document;var i=function() {i.c(arguments);};i.q=[];i.c=function(args) {i.q.push(args);};w.Intercom=i;var l=function() {var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if (document.readyState==='complete') {l();}else if (w.attachEvent) {w.attachEvent('onload',l);} else {w.addEventListener('load',l,false);}}})();
</script>
